import { render, staticRenderFns } from "./panelCreatives.vue?vue&type=template&id=3dd431f0&lang=pug"
import script from "./panelCreatives.vue?vue&type=script&lang=js"
export * from "./panelCreatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports